/**
 * Lectura del error del API: `{ status: 'failed', error: { type, message, code } }`
 * (`errorHandler.js`), que Angular entrega dentro de `HttpErrorResponse.error`.
 *
 * El `message` es el texto que el API redacta para el usuario —en los errores de negocio, en
 * castellano y a veces LITERAL exigido por la certificación (p. ej. el correo ya asociado a otro
 * trabajador)—: se muestra tal cual en vez de reemplazarlo por uno genérico.
 */
export interface ApiErrorInfo {
  /** Código HTTP (400, 404, 409, 422…), si lo hay. */
  status?: number;
  /** Código de negocio (`EMAIL_ALREADY_REGISTERED`, `DECREE_RESOLUTION_REQUIRED`…). */
  type?: string;
  message?: string;
  /**
   * Detalle estructurado de algunos errores de negocio (`error.details`): p. ej. el motivo de
   * `PERSONAL_EMAIL_NOT_ALLOWED` (`{ reason }`) o la advertencia vigente del correo de un tercero
   * (`{ warning }`). Sólo está presente cuando el API lo envía.
   */
  details?: Record<string, unknown>;
}

export function apiErrorOf(err: unknown): ApiErrorInfo {
  const candidate = err as {
    status?: number;
    error?: { error?: { type?: string; message?: string; details?: unknown } } | null;
  } | null;
  const body = candidate?.error?.error;
  const details = body?.details;
  return {
    status: typeof candidate?.status === 'number' ? candidate.status : undefined,
    type: typeof body?.type === 'string' ? body.type : undefined,
    message: typeof body?.message === 'string' && body.message.trim() ? body.message : undefined,
    ...(details && typeof details === 'object'
      ? { details: details as Record<string, unknown> }
      : {}),
  };
}
